import React from "react";
import { styled } from "@mui/material/styles";
import logo from "../assets/logo.png";

const CustomizedLogo = styled("img")`
  width: 100%;
  height: 152px;
  margin-bottom: 20px;

  object-fit: contain;
  object-position: center;

  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const Logo = () => {
  return (
    <CustomizedLogo
      src={logo}
      alt="Micree Logo"
    />
  );
};